import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ManageBuildings.Title',
    defaultMessage: 'Fortress - Manage Buildings',
  },
  header: {
    id: 'App.ManageBuildings.Header',
    defaultMessage: 'Manage Buildings',
  },
  buildingNumber: {
    id: 'App.ManageBuildings.BuildingsTable.BuildingNumber',
    defaultMessage: 'Building Number',
  },
  buildingAddress: {
    id: 'App.ManageBuildings.BuildingsTable.BuildingAddress',
    defaultMessage: 'Building Address',
  },
  buildingBIN: {
    id: 'App.ManageBuildings.BuildingsTable.BuildingBIN',
    defaultMessage: 'Building BIN',
  },
  edit: {
    id: 'App.ManageBuildings.BuildingsTable.Edit',
    defaultMessage: 'Edit',
  },
  success: {
    id: 'App.ManageBuildings.EditBuilding.Success',
    defaultMessage: 'Success',
  },
  error: {
    id: 'App.ManageBuildings.EditBuilding.Error',
    defaultMessage: 'Error',
  },
  successBody: {
    id: 'App.ManageBuildings.EditBuilding.successBody',
    defaultMessage: 'Building updated',
  },
  successSettingMessage: {
    id: 'App.ManageBuildings.EditBuilding.SuccessSettingMessage',
    defaultMessage: 'Setting updated',
  },
  errorSettingMessage: {
    id: 'App.ManageBuildings.EditBuilding.ErrorSettingMessage',
    defaultMessage: 'Error updating setting',
  },
  errorBody: {
    id: 'App.ManageBuildings.EditBuilding.errorBody',
    defaultMessage: 'Error updating Building',
  },
  errorMissingRequired: {
    id: 'App.ManageBuildings.EditBuilding.errorMissingRequired',
    defaultMessage: 'Missing required information',
  },
  errorInvalidZipCode: {
    id: 'App.ManageBuildings.EditBuilding.errorInvalidZipCode',
    defaultMessage: 'Invalid Zip Code / Postal Code',
  },
  buildingPISD: {
    id: 'App.ManageBuildings.EditBuilding.buildingPISD',
    defaultMessage: 'Building PISD',
  },
  xmlAltSiteName: {
    id: 'App.ManageBuildings.BuildingsTable.xmlAltSiteName',
    defaultMessage: 'Alternative Site Name (XML)',
  },
  heraSpecial: {
    id: 'App.ManageBuildings.BuildingsTable.HeraSpecial',
    defaultMessage: 'HERA Special',
  },
  minimumSetAside: {
    id: 'App.ManageBuildings.BuildingsTable.MinimumSetAside',
    defaultMessage: 'Minimum Set-Aside',
  },
  singleBuildingElection: {
    id: 'App.ManageBuildings.BuildingsTable.SingleBuildingElection',
    defaultMessage: 'Single Building Election',
  },
  rdSiteId: {
    id: 'App.ManageBuildings.BuildingsTable.RDSiteId',
    defaultMessage: 'RD Site ID',
  },
  singleBuildingElectionTooltip: {
    id: 'App.ManageBuildings.BuildingsTable.SingleBuildingElectionTooltip',
    defaultMessage:
      // eslint-disable-next-line max-len
      'Transfer Between Buildings: When this box is checked, indicating a single building election, each building is treated as an individual project. Consequently, tenants wishing to move to a unit in a different building must undergo a new income qualification process and perform a move-out and move-in.',
  },
  phBuildingNumber: {
    id: 'App.ManageBuildings.BuildingsTable.PHBuildingNumber',
    defaultMessage: 'PH Building Number',
  },
  phBuildingEntrance: {
    id: 'App.ManageBuildings.BuildingsTable.PHBuildingEntrance',
    defaultMessage: 'PH Building Entrance',
  },
  fundingType: {
    id: 'App.ManageBuildings.BuildingsTable.fundingType',
    defaultMessage: 'Funding Type',
  },
  errorFundingTypeRequired: {
    id: 'App.ManageBuildings.EditBuilding.errorFundingTypeInvalid',
    defaultMessage:
      'Funding Type is required for affordable properties with LIHTC and/or Tax Exempt Bonds.',
  },
  errorApplicableFractionInvalid: {
    id: 'App.ManageBuildings.EditBuilding.errorApplicableFractionInvalid',
    defaultMessage:
      'Applicable Fraction values must be between 0 and 100 with up to 2 decimal places.',
  },
  disabledApplicableFractionTooltip: {
    id: 'App.ManageBuildings.BuildingsTable.DisabledApplicableFractionTooltip',
    defaultMessage:
      'Unable to edit Applicable Fractions when building has unresolved NAUR event(s). ' +
      'Resolve NAUR events to update Applicable Fractions.',
  },
  errorNaurStatusLoadFailed: {
    id: 'App.ManageBuildings.EditBuilding.errorNaurStatusLoadFailed',
    defaultMessage:
      'NAUR event status could not be loaded. Applicable Fraction fields are disabled as a precaution.',
  },
  errorUnresolvedNaursOnSave: {
    id: 'App.ManageBuildings.EditBuilding.errorUnresolvedNaursOnSave',
    defaultMessage:
      'Unable to save: this building has unsatisfied NAUR events.',
  },
  errorApplicableFractionNaurApi: {
    id: 'App.ManageBuildings.EditBuilding.errorApplicableFractionNaurApi',
    defaultMessage:
      'Applicable Fraction cannot be updated while the building has unresolved NAUR events. ' +
      'Please resolve all NAUR events first.',
  },
  applicableFractionUnit: {
    id: 'App.ManageBuildings.BuildingsTable.ApplicableFractionUnit',
    defaultMessage: 'Applicable Fraction (Unit)',
  },
  applicableFractionFloorSpace: {
    id: 'App.ManageBuildings.BuildingsTable.ApplicableFractionFloorSpace',
    defaultMessage: 'Applicable Fraction (Floor Space)',
  },
  applicableFractionUnitTooltip: {
    id: 'App.ManageBuildings.BuildingsTable.ApplicableFractionUnitTooltip',
    defaultMessage:
      'The percentage of low-income units compared to all residential units. ' +
      'Calculated as: Low-income units / Total residential units. ' +
      'For NAUR, this value is used if it is lower than the Floor Space fraction.',
  },
  applicableFractionFloorSpaceTooltip: {
    id: 'App.ManageBuildings.BuildingsTable.ApplicableFractionFloorSpaceTooltip',
    defaultMessage:
      'The percentage of total residential square footage occupied by low-income units. ' +
      'Calculated as: Low-income unit square footage / Total residential square footage. ' +
      'For NAUR, this value is used if it is lower than the Unit fraction.',
  },
  certificateOfOccupancyDate: {
    id: 'App.ManageBuildings.BuildingsTable.CertificateOfOccupancyDate',
    defaultMessage: 'Certificate of Occupancy Date',
  },
  constructionType: {
    id: 'App.ManageBuildings.BuildingsTable.ConstructionType',
    defaultMessage: 'Construction Type',
  },
  rehab: {
    id: 'App.ManageBuildings.BuildingsTable.Rehab',
    defaultMessage: 'Rehab',
  },
  newConstruction: {
    id: 'App.ManageBuildings.BuildingsTable.NewConstruction',
    defaultMessage: 'New Construction',
  },
});

export default messages;
